import React from "react";

const SvgDropdown = props => <svg fill="none" viewBox="0 0 16 16" {...props}><path d="M10.586 6c.89 0 1.337 1.077.707 1.707l-2.586 2.586a1 1 0 0 1-1.414 0L4.707 7.707C4.077 7.077 4.523 6 5.414 6h5.172z" clipRule="evenodd" /></svg>;

export default SvgDropdown;